<app-card
  class="work-order-card"
  [ngClass]="{
    'work-order-closed': workOrder.closed || workOrder.progress === 100,
  }"
>
  <div class="link" role="link" routerLink="/work-order/{{ workOrder.id }}">
    <div class="card-title">
      <div class="title-left">
        @if (showProjectTitle && projectTitle) {
          <div class="project-title">{{ projectTitle }}</div>
        }
        <div class="work-order-title-line">
          @if (hasNotification) {
            <div class="update-notification"></div>
          }
          {{ workOrder.workOrderNo }}<span> {{ workOrder.statusName }}</span>
        </div>
      </div>
      <span
        [ngClass]="{ 'functional-unit': workOrder.activity?.functionalUnit }"
        (click)="addToSearch($event, workOrder.activity.functionalUnit)"
      >
        {{ workOrder.activity?.functionalUnit }}</span
      >
    </div>
    <div class="card-subtitle">{{ workOrder.title }}</div>
    <div class="card-content">
      <div class="progress">
        <app-progress
          [value]="workOrder.progress"
          [weeksProgress]="workOrder.weeksProgress"
          [displayLabel]="true"
        ></app-progress>
      </div>
      <div class="properties">
        <div class="property">
          <div class="label">{{ 'workOrderList.start' | translate }}</div>
          <div class="value">
            {{ workOrder.estimatedStartDate | dwoDate }}
          </div>
        </div>
        <div class="property">
          <div class="label">{{ 'workOrderList.finish' | translate }}</div>
          <div class="value">
            {{ workOrder.estimatedFinishDate | dwoDate }}
          </div>
        </div>
        <div class="property">
          <div class="label">
            {{ 'workOrderList.estimatedHours' | translate }}
          </div>
          <div class="value">{{ workOrder.estimatedHours }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    @if (showDownloadButton) {
      <button
        mat-icon-button
        (click)="toggleDownload()"
        class="download"
        [ngClass]="{ 'warning-color': refreshRequired, 'downloaded-state': workOrder.downloaded && !refreshRequired }"
        [disabled]="workOrder.isDownloading || isOfflineDownloadedLocked"
      >
        @if (!workOrder.isDownloading) {
          @if (getIcon() === 'database') {
            <mat-icon svgIcon="database"></mat-icon>
          } @else {
            <mat-icon>{{ getIcon() }}</mat-icon>
          }
        }
        @if (workOrder.isDownloading) {
          <mat-spinner diameter="25"></mat-spinner>
        }
      </button>
    }
    <button mat-icon-button (click)="openComments($event)" class="comments" aria-label="View comments">
      <mat-icon>comment</mat-icon>
      @if (workOrder.commentCount > 0) {
        <em class="comments-count-icon">{{ workOrder.commentCount }}</em>
      }
    </button>
    @if (showWeightBadge) {
      <button
        mat-icon-button
        (click)="openWeightReport($event)"
        class="comments weight-report"
        [class.weight-complete]="weightBadgeComplete"
        aria-label="View weight handling"
      >
        <mat-icon>scale</mat-icon>
        <em
          class="comments-count-icon weight-count-icon"
          [class.count-alert]="weightBadgeAlert"
          [class.count-success]="weightBadgeComplete"
        >
          {{ workOrder.weightLineSentCount }}/{{ workOrder.weightLineTotalCount }}
        </em>
      </button>
    }
    <button mat-icon-button (click)="toggleFavouriteWorkOrder()" class="favourite">
      <mat-icon>{{ workOrder.isFavourite ? 'star' : 'star_outline' }}</mat-icon>
    </button>
  </div>
  @if (workOrder.lastSyncedAt || workOrder.showChangesSaved) {
    <div class="last-synced" [class.saved-state]="workOrder.showChangesSaved">
      @if (workOrder.lastSyncedAt) {
        Last downloaded: {{ workOrder.lastSyncedAt | date: 'dd.MM.yyyy HH:mm' }}
        @if (workOrder.showChangesSaved) {
          • Changes saved
        } @else if ((workOrder.pendingOfflineChanges ?? 0) > 0) {
          • {{ workOrder.pendingOfflineChanges }} offline
          {{ workOrder.pendingOfflineChanges === 1 ? 'change' : 'changes' }}
        }
      } @else if (workOrder.showChangesSaved) {
        Changes saved
      }
    </div>
  }
</app-card>
